import {
  TextInput, TextInputProps, useTranslate,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { Box, InputLabel } from '@mui/material';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';
import { InputStateAdornment } from './InputStateAdornment';

export const GrayTextInputWithUpperLabel = (props: TextInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();
  const {
    helperText, isRequired, label, className, fullWidth, disabled, readOnly, InputProps, sx, ...rest
  } = props;
  const value = useWatch({ name: props.source });

  return (
    <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
      <InputLabel className="input-label" required={isRequired}>
        {translate(typeof label === 'string' ? label : '', { _: label })}
      </InputLabel>
      <InputHelperUnderLabel helperText={helperText} />
      <TextInput
        {...rest}
        disabled={disabled}
        readOnly={readOnly}
        className={className ? `${className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        fullWidth={fullWidth ?? true}
        InputProps={{
          ...InputProps,
          notched: false,
          endAdornment: (
            <>
              {InputProps?.endAdornment}
              <InputStateAdornment
                value={value}
                disabled={disabled}
                readOnly={readOnly}
              />
            </>
          ),
        }}
        sx={{
          width: '100%',
          ...sx,
        }}/>
    </Box>
  );

};
